import { createSlice, PayloadAction } from '@reduxjs/toolkit';

  export const ACCESS_LEVELS = {
      NO_ACCESS: 'Request Details',
      REQUESTED_ACCESS: 'ACCESS REQUESTED',
      HAS_ACCESS: 'VIEW DETAILS'
  };

  interface UserAccessState {
    allDelegates: {
      totalItems: number;
      currentPage: number;
      data: any;
      previousQuery: Record<string, any>;
    };
    approvedDelegates: {
      totalItems: number;
      currentPage: number;
      data: any;
      previousQuery: Record<string, any>;
    };
    approvedPhysicians: {
      totalItems: number;
      currentPage: number;
      data: any;
      previousQuery: Record<string, any>;
    };
    myFilteredPhysicians: {
      totalItems: number;
      currentPage: number;
      data: any;
      previousQuery: Record<string, any>;
    };
    groups: {
      totalItems: number;
      currentPage: number;
      data: any;
      previousQuery: Record<string, any>;
    };
    pendingDelegates: {
      totalItems: number;
      currentPage: number;
      data: any;
      previousQuery: Record<string, any>;
    };
    pendingPhysicians: {
      totalItems: number;
      currentPage: number;
      data: any;
      previousQuery: Record<string, any>;
    };
    pixeUserSearchResults: {
      totalItems: number;
      currentPage: number;
      data: any;
      previousQuery: Record<string, any>;
    };
    physicianBeingAccessed: {
      mpin: string | null;
      id: string | null;
      isRegistered: boolean;
      accessLevel: string;
    };
    physicianSearchResults: {
      totalItems: number;
      currentPage: number;
      data: any;
      previousQuery: Record<string, any>;
    };
    refreshUser: boolean;
    user: any;
    validatedGroup: any;
  }

  const initialState: UserAccessState = {
    allDelegates: {
      totalItems: 0,
      currentPage: 0,
      data: null,
      previousQuery: {},
    },
    approvedDelegates: {
      totalItems: 0,
      currentPage: 0,
      data: null,
      previousQuery: {},
    },
    approvedPhysicians: {
      totalItems: 0,
      currentPage: 0,
      data: null,
      previousQuery: {},
    },
    myFilteredPhysicians: {
      totalItems: 0,
      currentPage: 0,
      data: null,
      previousQuery: {},
    },
    groups: {
      totalItems: 0,
      currentPage: 0,
      data: null,
      previousQuery: {},
    },
    pendingDelegates: {
      totalItems: 0,
      currentPage: 0,
      data: null,
      previousQuery: {},
    },
    pendingPhysicians: {
      totalItems: 0,
      currentPage: 0,
      data: null,
      previousQuery: {},
    },
    pixeUserSearchResults: {
      totalItems: 0,
      currentPage: 0,
      data: null,
      previousQuery: {},
    },
    physicianBeingAccessed: {
      mpin: null,
      id: null,
      isRegistered: false,
      accessLevel: ACCESS_LEVELS.NO_ACCESS,
    },
    physicianSearchResults: {
      totalItems: 0,
      currentPage: 0,
      data: null,
      previousQuery: {},
    },
    refreshUser: true,
    user: null,
    validatedGroup: null,
  };

  const userAccessSlice = createSlice({
    name: 'userAccess',
    initialState,
    reducers: {
      setUserAccess: (state, action: PayloadAction<UserAccessState>) => {
        return { ...state, ...action.payload };
      },
      clearUserAccess: () => initialState,
    },
  });

  export const { setUserAccess, clearUserAccess } = userAccessSlice.actions;
  export default userAccessSlice.reducer;